import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { MapDistanceModal } from 'stories/components'

const ShowDistanceDialog = ({ show, proceed, title, options }: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <MapDistanceModal
      isOpen={show}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      title={title}
      options={options}
    />
  )
}

const showOptionDlg = confirmable(ShowDistanceDialog)

const createModalOptions = createConfirmation(showOptionDlg)

export const showDistances = (title: string, options: { addresses: string[] }) => createModalOptions({ title, options })
